import React, { useEffect, useState } from 'react';
import { Calendar, PartyPopper, ChevronRight } from 'lucide-react';
import { Card } from '../ui/Card';
import { Employee } from '../../types/hr.types';
import { mockEmployees } from '../../utils/mockData';
import { isBirthdayThisWeek, isBirthdayToday } from '../../utils/dateUtils';
import { ShowMoreModal } from '../ui/ShowMoreModal';
const MAX_VISIBLE = 4;
export function BirthdaysThisWeekWidget() {
  const [employees, setEmployees] = useState<Employee[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      const weekBirthdays = mockEmployees.filter(e => e.isActive && isBirthdayThisWeek(e.birthday)).sort((a, b) => a.birthday.localeCompare(b.birthday));
      setEmployees(weekBirthdays);
      setIsLoading(false);
    }, 700);
    return () => clearTimeout(timer);
  }, []);
  const visibleEmployees = employees.slice(0, MAX_VISIBLE);
  const hasMore = employees.length > MAX_VISIBLE;
  const remainingCount = employees.length - MAX_VISIBLE;
  const EmployeeItem = ({
    employee
  }: {
    employee: Employee;
  }) => {
    const isToday = isBirthdayToday(employee.birthday);
    return <div className={`flex items-center justify-between p-3 rounded-lg ${isToday ? 'bg-pink-50 border border-pink-100' : 'hover:bg-gray-50'}`} data-id="element-935">
        <div className="flex items-center gap-3" data-id="element-936">
          <div className="h-8 w-8 rounded-full bg-gray-200 overflow-hidden" data-id="element-937">
            <img src={employee.photoUrl} alt="" className="h-full w-full object-cover" data-id="element-938" />
          </div>
          <div data-id="element-939">
            <p className="text-sm font-medium text-gray-900" data-id="element-940">{employee.name}</p>
            <p className="text-xs text-gray-500" data-id="element-941">
              {employee.birthday} • {employee.department}
            </p>
          </div>
        </div>
        {isToday && <PartyPopper className="h-4 w-4 text-pink-500" data-id="element-942" />}
      </div>;
  };
  if (isLoading) {
    return <Card title="Birthdays This Week" icon={<Calendar className="h-5 w-5 text-purple-500" data-id="element-944" />} data-id="element-943">
        <div className="space-y-3 animate-pulse" data-id="element-945">
          {[1, 2, 3].map(i => <div key={i} className="h-12 bg-gray-100 rounded-lg" data-id="element-946" />)}
        </div>
      </Card>;
  }
  return <>
      <Card title="Birthdays This Week" icon={<Calendar className="h-5 w-5 text-purple-500" data-id="element-948" />} data-id="element-947">
        {employees.length > 0 ? <div className="space-y-1" data-id="element-949">
            {visibleEmployees.map(employee => <EmployeeItem key={employee.id} employee={employee} data-id="element-950" />)}
            {hasMore && <button onClick={() => setShowModal(true)} className="w-full mt-2 py-2 px-3 text-sm font-medium text-orange-600 hover:text-orange-700 hover:bg-orange-50 rounded-lg transition-colors flex items-center justify-center gap-1" data-id="element-951">
                Show {remainingCount} more
                <ChevronRight className="h-4 w-4" data-id="element-952" />
              </button>}
          </div> : <div className="text-center py-8 text-gray-500" data-id="element-953">
            <p data-id="element-954">No upcoming birthdays this week.</p>
          </div>}
      </Card>
      <ShowMoreModal isOpen={showModal} onClose={() => setShowModal(false)} title={`All Birthdays This Week (${employees.length})`} data-id="element-955">
        <div className="space-y-1" data-id="element-956">
          {employees.map(employee => <EmployeeItem key={employee.id} employee={employee} data-id="element-957" />)}
        </div>
      </ShowMoreModal>
    </>;
}